import { getPreviewLabels } from './helpers';

export const getPrivacySettingsText = getPreviewLabels(
  'client.privacy-settings.open-button'
);
export const getUSAPrivacySettingsText = getPreviewLabels(
  'client.usa-privacy-settings.open-button'
);
